<template>
  <div class="pcbaPage">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
      type="selection"
      width="39"
      >

      </el-table-column>
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column prop="sn" label="SN" align="center" sortable="custom" min-width="110px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.sn ? scope.row.sn : '【未生成SN】'" placement="top" :open-delay="300">
            <span class="textOverflow allowSkip" @click="SNClickBtn($event, scope.row)">
              {{ scope.row.sn ? scope.row.sn : "【未生成SN】" }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="chipId" label="主控ID" align="center" sortable="custom" min-width="160px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.chipId" class="item" effect="dark" placement="top" :open-delay="300">
            <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ scope.row.chipId }}</div>
            <span class="textOverflow">
              {{ scope.row.chipId}}
            </span>
          </el-tooltip>          
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="otherSn" label="其它SN" align="center" sortable="custom" min-width="160px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.otherSn" class="item" effect="dark" placement="top" :open-delay="300">
            <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.otherSn, null, 2) }}</div>
            <span class="textOverflow">
              {{ scope.row.otherSn}}
            </span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="testTimes" label="直通" align="center" width="105px">
        <template slot-scope="scope">
          <span v-if="scope.row.sn && scope.row.testTimes && !scope.row.failTimes" class="textOverflow">是</span>
          <span v-else-if="scope.row.sn && !scope.row.testTimes && !scope.row.failTimes" class="textOverflow">-</span>
          <span v-else-if="scope.row.sn && scope.row.failTimes" class="textOverflow">否</span>
          <span v-else-if="!scope.row.sn" class="textOverflow">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="testTimes" label="测试次数" align="center" width="105px"
        sortable="custom">
        <template slot-scope="scope">
          <span class="textOverflow">{{ scope.row.testTimes }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="failTimes" label="错误次数" align="center" width="105px"
        sortable="custom">
        <template slot-scope="scope">
          <span class="textOverflow">{{ scope.row.failTimes }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="workStationId"
        label="状态"
        align="center"
        show-overflow-tooltip
        sortable="custom" width="135px"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.workStation" class="textOverflow">{{
            scope.row.workStation.name
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="115px">
        <template slot-scope="scope">
          <!-- // 已发货的不能锁定 -->
          <span v-if="scope.row.workStation && (scope.row.workStation.id=='36226401431584768' || scope.row.workStation.id=='-3' || scope.row.workStation.id=='-10')"
          > - </span>
          <el-tooltip v-if="scope.row.workStation && scope.row.workStation.id!='-999' && scope.row.workStation.id!='36226401431584768' && scope.row.workStation.id>='-1' && scope.row.workStation.id!='-10' && scope.row.workStation.id!='-3'" class="item" effect="dark" content="回退至上一工序" placement="top" :open-delay="300">
            <i @click="rollbackSop($event, scope.row)" class="iconfont icon-huitui"></i>
          </el-tooltip>
          <el-tooltip v-if="scope.row.workStation && scope.row.workStation.id!='36226401431584768' && scope.row.workStation.id!='-999' && scope.row.workStation.id!='-3' && scope.row.workStation.id!='-10'"
                      class="item" effect="dark" content="异常锁定" placement="top" :open-delay="300">
            <i @click="lockPcba($event, scope.row)" class="el-icon-lock"></i>
          </el-tooltip>
          <el-tooltip v-if="scope.row.workStation && scope.row.workStation.id=='-999'"
                      class="item" effect="dark" content="解锁异常" placement="top" :open-delay="300">
            <i @click="unlockPcba($event, scope.row)" class="el-icon-unlock"></i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.workStation && scope.row.workStation.id!='-999' && scope.row.workStation.id!='36226401431584768' && scope.row.workStation.id>='-1' && scope.row.workStation.id!='-10' && scope.row.workStation.id!='-3'"
            class="item" effect="dark" content="借出" placement="top" :open-delay="300">
            <i @click="lendOutPcba($event, scope.row)" class="iconfont icon-jiechu">&nbsp;</i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.workStation && scope.row.workStation.id!='36226401431584768' && scope.row.workStation.id>='-1' && scope.row.workStation.id!='-10' && scope.row.workStation.id!='-999' && scope.row.workStation.id!='-3'"
            class="item" effect="dark" content="送修" placement="top" :open-delay="300">
            <i @click="repairPcba($event, scope.row)" class="iconfont icon-weixiu">&nbsp;</i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getSmtOrderPcba"
    ></pagination>
    <myDrawer ref="myDrawer" :drawerOption="drawerOption"></myDrawer>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import {
  apiSmtOrderLockPcba,
  apiSmtOrderLendOutPcba,
  apiSmtOrderPcbas, apiSmtOrderUnlockPcba,
  apiSmtOrderSopRollback
} from "@/api/SmtOrder.js";
import { apiRepairAdd } from "@/api/repair.js";
import myDrawer from "@/components/myDrawer.vue";
export default {
  components: {
    pagination,
    myDrawer
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    devicesSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      drawerOption: {
        currentSNId: "",
        currentSNName: "",
      },
      multipleSelection: [],
    };
  },
  methods: {
    // 表格数据
    async getSmtOrderPcba(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiSmtOrderPcbas({
        id: this.tabPaneValue,
        ...this.devicesSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getSmtOrderPcba();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getSmtOrderPcba();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getSmtOrderPcba();
    },
    // 点击sn列
    SNClickBtn(e, row) {
      e.target.blur();
      this.drawerOption = {
        currentSNId: row.id,
        currentSNName: row.sn,
      }
      this.$nextTick(() => {
        this.$refs.myDrawer.getPcbaLife();
      })
    },
    // 产品列表表格导出
    tableExport(command) {
      this.$confirm(`导出数据可能需要几分钟的时间，确定导出吗？`, `导出${command}`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await apiSmtOrderPcbas({
          id: this.tabPaneValue,
          ...this.devicesSearchForm,
          export: true,
          desc: this.desc,
          orderBy: this.orderBy,
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 回退工序
    rollbackSop(e, row) {
      e.target.blur();
      const h = this.$createElement;
      const st = row.sn;
      this.$msgbox({
        title: `回退确认`,
        message: h("div", null, [
          h("span", null, "请输入SN：【"),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, "】以确认回退！"),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiSmtOrderSopRollback({
          id: row.id,
        });
        if (res.code == 0) {
          this.getSmtOrderPcba();
          this.$message({
            message: "回退成功",
            type: "success",
          });
        }
      });
    },
    // 送修
    repairPcba(e, row) {
      e.target.blur();
      const h = this.$createElement;
      const st = row.sn;
      this.$msgbox({
        title: `送修确认`,
        message: h("div", null, [
          h("span", null, "请输入SN：【"),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, "】以确认送修！"),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiRepairAdd({
          id: "1",
          sn: row.sn,
          problemResultCode: "010A",
          problemDes: "AIM页面送修",
        });
        if (res.code == 0) {
          this.getSmtOrderPcba();
          this.$message({
            message: "送修成功",
            type: "success",
          });
        }
      });
    },
    // 借出产品
    lendOutPcba(e, row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = row.sn ? "请输入SN：【" : "请输入工单号:【";
      const st = row.sn ? row.sn : row.smtOrder.orderNumber;
      this.$msgbox({
        title: `产品借出确认`,
        message: h("div", null, [
          h("span", null, tt),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, "】以确认借出产品！"),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiSmtOrderLendOutPcba({
          id: row.smtOrder.id,
          pcbaId: row.id
        });
        if (res.code == 0) {
          this.getSmtOrderPcba();
          this.$message({
            type: "success",
            message: "产品借出成功！"
          });
        }
      });
    },
    // 锁定产品
    lockPcba(e, row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = row.sn ? "请输入SN：【" : "请输入工单号:【";
      const st = row.sn ? row.sn : row.smtOrder.orderNumber;
      this.$msgbox({
        title: `警告：产品锁定后将被生产拦截！`,
        message: h("div", null, [
          h(
              "span",
              null,
              tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确认锁定产品！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiSmtOrderLockPcba({
          id: row.smtOrder.id,
          pcbaId: row.id
        });
        if (res.code == 0) {
          this.getSmtOrderPcba();
          this.$message({
            type: "success",
            message: "产品锁定成功，该产品将被生产拦截！"
          });
        }
      });
    },
    // 解锁产品
    unlockPcba(e, row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = row.sn ? "请输入SN：【" : "请输入工单号:【";
      var st = row.sn ? row.sn : row.smtOrder.orderNumber;
      this.$msgbox({
        title: `温馨提示：解锁后产品将回到【待生产】状态`,
        message: h("div", null, [
          h(
              "span",
              null,
              tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确认解锁产品！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st || instance.inputValue.indexOf("-")==0) {
              st = instance.inputValue;
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiSmtOrderUnlockPcba({
          id: row.smtOrder.id,
          pcbaId: row.id,
          newSn: st
        });
        if (res.code == 0) {
          this.getSmtOrderPcba();
          this.$message({
            type: "success",
            message: res.msg
          });
        }
      });
    },

  },
};
</script>

<style lang="less" scoped>
.pcbaPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.item {
  margin-right: 2px;
  margin-left: 2px;
}
</style>
